import React from 'react';
import './TomaSelector.css';

function TomaSelector({ tomas, selectedToma, onTomaChange, loading }) {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  if (loading) {
    return <span className="toma-selector-loading">Cargando tomas...</span>;
  }

  if (!tomas || tomas.length === 0) {
    return <span className="toma-selector-empty">No hay tomas disponibles</span>;
  }

  return (
    <div className="toma-selector">
      <label htmlFor="toma-select">Toma:</label>
      <select
        id="toma-select"
        value={selectedToma?.id || ''}
        onChange={(e) => {
          const tomaId = parseInt(e.target.value);
          const toma = tomas.find(t => t.id === tomaId);
          onTomaChange(toma);
        }}
      >
        {tomas.map((toma) => (
          <option key={toma.id} value={toma.id}>
            Toma {toma.id} - {formatDate(toma.fecha_fin)}
          </option>
        ))}
      </select>
    </div>
  );
}

export default TomaSelector;
